import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import AOS from 'aos'
import router from './router'
import * as log from 'loglevel'
import 'aos/dist/aos.css'
import './scss/main.scss'
import 'typeface-montserrat'
import 'typeface-karla'
import 'typeface-titillium-web'
import VueMultianalytics from 'vue-multianalytics'
import analyticsConfig from './config/analytics'
import Icon from 'vue-awesome/components/Icon'
import { ResizeObserver } from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
import VueHead from 'vue-head'

window.log = log.noConflict()
log.setLevel(process.env.VUE_APP_LOG_LEVEL)

Vue.component('icon', Icon)
Vue.component('resize-observer', ResizeObserver)

Vue.use(VueHead)
Vue.use(VueMultianalytics, analyticsConfig)
Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  render: h => h(App),
  created() {
    AOS.init()
  },
  router
}).$mount('#app')
